var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventCard } from "../../EventCard";
var Asian = /** @class */ (function (_super) {
    __extends(Asian, _super);
    /* istanbul ignore next */
    /* super transpiles to  var _this = _super.call(this) || this; */
    function Asian(props) {
        var _this = _super.call(this, props) || this;
        _this.cardTypeClass = "rj-ev-list__ev-card--asian";
        _this.buttonsHolderClass = "rj-ev-list__ev-card__buttons-holder--asian";
        return _this;
    }
    return Asian;
}(EventCard));
export { Asian };
//# sourceMappingURL=Asian.js.map